/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
const $ = require("jquery")
$.Datatable = require("datatables.net");
const Bonushistory = () => {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  
  let baseUrl;
  if (nodeMode === "development") {
    baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  const [user, setUser] = useState()
  
  //use for pagination..
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  let [limit,setLimit] = useState(10);
  
  const setpageLimit = (event)=>{
      let key = event.target.value
      setLimit(key);
  }
  
  //user for searching.. (kept variable even if unused to avoid breaking potential future logic)
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState(0);
  //react paginate..
  const handlePageClick = async (data) => {
      let currentPage = data.selected + 1;
      setPageNumber(currentPage);
  };
  const profle = () => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios.get(baseUrl+`txn/bonusbyadmin/all?page=${pageNumber}&_limit=${limit}`, { headers })
      .then((res) => {
        setUser(res.data.admin)
        setNumberOfPages(res.data.totalPages)
      })
  }
  const dateFormat=(e)=>{
    const date = new Date(e); 
    const newDate = date.toLocaleString('default', { month: 'long',day:'numeric',hour:'numeric',hour12:true,minute:'numeric' });
    return newDate;
  }
  useEffect(() => {
    profle()
  }, [pageNumber,limit])
  if(user === undefined){
      return null
  }
  // Premium UI Styles
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
    
    .admin-mgmt-page { background: #f0f2f5; min-height: 100vh; padding: 20px; font-family: 'Poppins', sans-serif; }
    
    /* Card & Header */
    .modern-card { background: #fff !important; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); overflow: hidden; margin-top: 20px; }
    .card-header-custom { background: linear-gradient(45deg, #57155a, #8e44ad); padding: 20px; }
    .card-title-custom { margin: 0; color: white !important; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
    /* Controls Bar */
    .controls-bar { display: flex; justify-content: flex-end; padding: 15px 20px; background: #fafafa; border-bottom: 1px solid #eee; }
    .select-limit { padding: 8px 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 0.9rem; outline: none; background: white; color: #333; cursor: pointer; }
    .select-limit:focus { border-color: #57155a; }
    /* Table Styling */
    .table-responsive { overflow-x: auto; padding: 0 20px 20px 20px; }
    .custom-table { width: 100%; border-collapse: collapse; min-width: 800px; }
    
    .custom-table thead th { background: #f8f9fa !important; color: #636e72 !important; font-weight: 700; text-transform: uppercase; font-size: 0.8rem; padding: 15px 20px; text-align: left; border-bottom: 2px solid #eee; }
    .custom-table tbody td { padding: 15px 20px; border-bottom: 1px solid #f1f1f1; vertical-align: middle; color: #2d3436 !important; font-size: 0.9rem; }
    .custom-table tbody tr:hover { background: #fafafa !important; }
    
    /* Specific Column Styles */
    .id-cell { font-family: monospace; color: #666; font-size: 0.85rem; }
    .amount-text { font-weight: 700; color: #2ecc71; }
    .status-badge { background: #e8f5e9; color: #2e7d32; padding: 4px 10px; border-radius: 20px; font-weight: 700; font-size: 0.75rem; text-transform: uppercase; }
    .btn-link-user { color: #57155a; text-decoration: none; font-weight: 600; background: #f3e5f5; padding: 5px 10px; border-radius: 6px; font-size: 0.85rem; transition: 0.2s; }
    .btn-link-user:hover { background: #e1bee7; }
    /* Pagination */
    .pagination { display: flex; list-style: none; padding: 0; justify-content: center; gap: 5px; margin-top: 20px; flex-wrap: wrap; }
    .page-item { display: inline-block; }
    .page-link { padding: 8px 14px; border-radius: 8px; border: 1px solid #eee; color: #666 !important; cursor: pointer; text-decoration: none; font-size: 0.9rem; font-weight: 500; display: block; background: white; transition: 0.2s; }
    .page-link:hover { background: #f9f9f9; color: #57155a !important; border-color: #ddd; }
    .active .page-link { background: #57155a; color: white !important; border-color: #57155a; box-shadow: 0 4px 10px rgba(87, 21, 90, 0.3); }
  `;
  return (
    <div className="admin-mgmt-page">
      <style>{styles}</style>
      
      <div className="row">
          <div className="col-12">
              <div className="modern-card">
                  
                  {/* Header */}
                  <div className="card-header-custom">
                      <h4 className="card-title-custom">Bonus History</h4>
                  </div>
                  
                  {/* Controls */}
                  <div className="controls-bar">
                      <select className='select-limit' id='pagelimit' name='pagelimit' onChange={setpageLimit}>
                          <option value="10">10 Rows</option>
                          <option value="20">20 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                          <option value="500">500 Rows</option>
                      </select>
                  </div>
                  {/* Table */}
                  <div className="table-responsive">
                      <table className="custom-table">
                          <thead>
                              <tr>
                                  <th>#</th>
                                  <th>ID</th>
                                  <th>Phone</th>
                                  <th>User Name</th>
                                  <th>Amount</th>
                                  <th>Status</th>
                                  <th>Date</th>
                              </tr>
                          </thead>
                          
                          <tbody>
                          {user && user.map((data,key)=>(
                              <tr key={key}>
                                  <td style={{color: '#999', fontWeight: 'bold'}}>{(pageNumber === 0 ? 0 : pageNumber - 1) * limit + (key + 1)}</td>
                                  <td className="id-cell">{data._id}</td>
                                  <td>
                                    <span style={{fontWeight:'500'}}>{data.User_id ? data.User_id.Phone : '-'}</span>
                                  </td>
                                  <td>
                                    {data.User_id ? (
                                      <Link className="btn-link-user" to={`/user/view_user/${data.User_id._id}`} >
                                        {data.User_id.Name}
                                      </Link>
                                    ) : <span style={{color:'#999'}}>N/A</span>}
                                  </td>
                                  
                                  <td className="amount-text">₹{data.amount}</td>
                                  <td><span className="status-badge">{data.status}</span></td>
                                  <td style={{fontSize:'0.9rem', color:'#666'}}>{dateFormat(data.createdAt).split(',')[0]} </td>
                              </tr>
                          ))}
                        </tbody>
                      </table>
                  </div>
                  {/* Pagination */}
                  <div className='p-3'>
                    <ReactPaginate
                        previousLabel={"← Prev"}
                        nextLabel={"Next →"}
                        breakLabel={"..."}
                        pageCount={numberOfPages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        activeClassName={"active"}
                    />
                  </div>
              </div>
          </div>
      </div>
    </div>
  )
}
export default Bonushistory